const FORMATION_KINDS = ['formation-initiale', 'formation-continue'] as const;
type formationKindType = (typeof FORMATION_KINDS)[number];

type trainingOptionType = 'inter' | 'intra';
type formationWithOptionsType = {
    option: trainingOptionType | undefined;
    date: string;
};
type formationWithoutOptionsType = { isSelected: boolean; date: string };
type formationsWithOptionsSummaryType = Record<
    formationWithOptionSlugType,
    formationWithOptionsType
>;

type formationsWithoutOptionsSummaryType = Record<
    formationWithoutOptionSlugType,
    formationWithoutOptionsType
>;

type selectedTrainingType = { trainingOption: string; date: string };

type selectedTrainingsType = Record<
    formationWithoutOptionSlugType | formationWithOptionSlugType,
    selectedTrainingType
>;

const TRAINING_WITHOUT_OPTIONS_SLUGS = [
    'ENTRETIEN_ESPACE_VERT_2026_2027',
    'ALTERNATIVES_ARROSAGE_2026_2027',
    'REALISER_UN_MASSIF_2026_2027',
] as const;

type formationWithoutOptionSlugType = (typeof TRAINING_WITHOUT_OPTIONS_SLUGS)[number];

const TRAINING_WITH_OPTIONS_SLUGS = [
    'JARDIN_BIODIVERSITE_2026_2027',
    'FAUNE_2026_2027',
    'EAU_FRAICHEUR_URBAINE_2026_2027',
    'SOLS_BIODIVERSITE_2026_2027',
    'VEGETALISER_VILLE_2026_2027',
    'GESTION_ECOLOGIQUE_2026_2027',
    'EVALUER_IMPACT_ENVIRONNEMENTAL_2026_2027',
    'ECONOMIE_CIRCULAIRE_REEMPLOI_2026_2027',
    'IA_CONCEPTION_PAYSAGE_2026_2027',
    'IA_GESTION_ADMINISTRATIVE_2026_2027',
    'IA_APPEL_OFFRE_2026_2027',
    'MODELISATION_3D_2026_2027',
    'SIG_PAYSAGE_2026_2027',
    'PLU_PAYSAGE_2026_2027',
    'CONCEVOIR_JARDIN_PRIVE_2026_2027',
    'HISTOIRE_JARDINS_2026_2027',
] as const;

type formationWithOptionSlugType = (typeof TRAINING_WITH_OPTIONS_SLUGS)[number];

const MASTER_SLUGS = ['MASTER1'] as const;

type masterSlugType = (typeof MASTER_SLUGS)[number];

type companyOpcoFundingType = {
    kind: 'company' | 'opco';
    company: string;
    siret: string;
    address: string;
    managementName: string;
    managementEmail: string;
};

type fundingType =
    | companyOpcoFundingType
    | { kind: 'vivea' }
    | { kind: 'france-travail' }
    | { kind: 'auto' };

type fundingKindType = fundingType['kind'];
export type {
    trainingOptionType,
    formationWithOptionsType,
    formationWithoutOptionsType,
    formationsWithOptionsSummaryType,
    formationWithOptionSlugType,
    formationWithoutOptionSlugType,
    formationsWithoutOptionsSummaryType,
    masterSlugType,
    fundingType,
    fundingKindType,
    companyOpcoFundingType,
};

export { TRAINING_WITH_OPTIONS_SLUGS, TRAINING_WITHOUT_OPTIONS_SLUGS, MASTER_SLUGS };

export type { formationKindType, selectedTrainingsType, selectedTrainingType };
export { FORMATION_KINDS };
